import { BaseRequest, IBaseRequest } from '../../BaseRequest';

export interface IDeleteItemRequest extends IBaseRequest {
    id: string;
    systemId?: string;
    priceList?: string;
    date?: Date;
}

export class DeleteItemRequest extends BaseRequest implements IDeleteItemRequest {

    public id: string;
    public systemId?: string;
    public priceList?: string;
    public date?: Date;

    constructor(server: string, session: string, id: string, otherOptions: any) {
        super(server, session);
        this.id = id;
        this.systemId = otherOptions.systemId;
        this.priceList = otherOptions.priceList;
        this.date = otherOptions.date;
    }

    public toXml(): string {
        var parameters: string = super.toXml();

        parameters += this.makeNode(this.id, 'id');
        parameters += this.makeNode(this.systemId, 'systemId');
        parameters += this.makeNode(this.priceList, 'priceList');
        parameters += this.makeNode(this.date, 'date');

        return super.wrapperXml('DeleteItem', parameters);
    }
}
